import * as z from 'zod';

export const faqFormSchema = z.object({
  questions: z.array(
    z.object({
      title: z.string().min(1),
      answer: z.string().min(1),
    }),
  ),
});

export type FaqForm = z.TypeOf<typeof faqFormSchema>;
